import React, { FC } from 'react'
import { Icon, Tooltip } from '@wmgtech/legato'

import { cn } from 'shared/utils'

import { iconNames } from 'modules/Feed/consts'

import { IStoryHeaderActionProps } from './StoryHeader.props'
import styles from './StoryHeaderAction.module.scss'

export const StoryHeaderAction: FC<IStoryHeaderActionProps> = ({ action }) => {
  return (
    <Tooltip message={action.tooltipText || ''} colorType="dark">
      <div
        className={cn(styles.listItem, 'story-header__list', { 'story-header__list--success': true })}
        onClick={action.action}
      >
        <div>{action.title}</div>
        <Icon name={iconNames[action.key]} />
      </div>
    </Tooltip>
  )
}


